export const formatDate = (
  dateString: string,
  format: 'short' | 'long' = 'short',
  options?: { yearFormat?: '2-digit' | 'numeric' },
): string => {
  const date = new Date(dateString);

  if (format === 'long') {
    return new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: options?.yearFormat || 'numeric',
  }).format(date);
};
